import React, { Component } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

interface SpinnerProps {
  color?: any; // Optional prop: color
  size?: string;  // Optional prop: size
}
export default class Spinner extends Component<SpinnerProps> {
  render() {
    const { color = 'inherit', size = '2rem' } = this.props;

    return (
      <div className="spinnerCircle">
        <CircularProgress color={color} size={size} />
      </div>
    );
  }
}
